const compare = require('./compare')
const gte = (a, b, loose) => compare(a, b, loose) >= 0
module.exports = gte



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/gte.js
// module id = 380
// module chunks = 0